import { render, staticRenderFns } from "./view-iybr-action-buttons.vue?vue&type=template&id=4485ffcc"
import script from "./view-iybr-action-buttons.ts?vue&type=script&lang=ts&external"
export * from "./view-iybr-action-buttons.ts?vue&type=script&lang=ts&external"
import style0 from "./view-iybr-action-buttons.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4485ffcc')) {
      api.createRecord('4485ffcc', component.options)
    } else {
      api.reload('4485ffcc', component.options)
    }
    module.hot.accept("./view-iybr-action-buttons.vue?vue&type=template&id=4485ffcc", function () {
      api.rerender('4485ffcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/view-in-year-budget-request/view-iybr-action-buttons/view-iybr-action-buttons.vue"
export default component.exports